import React, { lazy } from "react"
import { Redirect } from "react-router-dom"

// Eager-load login so the public entry route stays fast
import Login from "../pages/Authentication/Login"

function RootRedirect() {
  return <Redirect to="/dashboard" />
}

const UserProfile = lazy(() => import("../pages/Authentication/UserProfile"))
const ResetPassword = lazy(() => import("../pages/Authentication/ResetPassword"))
const Logout = lazy(() => import("../pages/Authentication/Logout"))
const Register = lazy(() => import("../pages/Authentication/Register"))
const ForgetPwd = lazy(() => import("../pages/Authentication/ForgetPassword"))

const Dashboard = lazy(() => import("../pages/Dashboard/index"))
const Project = lazy(() => import("../pages/Dashboard/project"))
const ProjectDetail = lazy(() => import("../pages/Dashboard/project-detail"))
const ProjectComapre = lazy(() => import("../pages/Dashboard/project-compare"))
const MlsComapre = lazy(() => import("../pages/Dashboard/project-comparemls"))
const myProject = lazy(() => import("../pages/Dashboard/myproject"))
const myTransection = lazy(() => import("../pages/Dashboard/mytransection"))

const clientApp = lazy(() => import("../pages/Clients/client-app"))
const ClientDocument = lazy(() => import("../pages/Clients/client-documents"))
const ClientMessage = lazy(() => import("../pages/Clients/client-message"))
const preFrence = lazy(() => import("../pages/Prefrences/index"))
const myListing = lazy(() => import("../pages/Prefrences/mylisings"))
const createListing = lazy(() => import("../pages/Prefrences/createlisting"))
const calCulator = lazy(() => import("../pages/Prefrences/calculator"))
const mySource = lazy(() => import("../pages/Prefrences/mysource"))
const SellerShowing = lazy(() => import("../pages/Prefrences/sellershowing"))
const deals = lazy(() => import("../pages/Prefrences/deals"))
const MyLawyer = lazy(() => import("../pages/Clients/mylawyer"))

const addListing = lazy(() => import("../pages/Prefrences/add-listing"))
const VisitedAddListing = lazy(() => import("../pages/Prefrences/visited-add-listing"))
const receivedAddListing = lazy(() => import("../pages/Prefrences/received-add-listing"))
const sentAddListing = lazy(() => import("../pages/Prefrences/sent-add-listing"))

const clientProfile = lazy(() => import("../pages/Clients/client-profile"))
const clientProfileNew = lazy(() => import("../pages/Clients/client-profile-new"))
const generalSetting = lazy(() => import("../pages/Clients/general-setting"))
const memberInfo = lazy(() => import("../pages/Clients/member-info"))

const homePref = lazy(() => import("../pages/Prefrences/home-pref"))
const impDates = lazy(() => import("../pages/Prefrences/important-destinations"))
const sellersChecklist = lazy(() => import("../pages/Prefrences/sellersChecklist"))
const buyersChecklist = lazy(() => import("../pages/Prefrences/buyersChecklist"))
const manageListing = lazy(() => import("../pages/Prefrences/manage-listing"))
const comapreMatch = lazy(() => import("../pages/Prefrences/comapre-match"))
const comapreNotMatch = lazy(() => import("../pages/Prefrences/comapre-not-match"))
const comapreNiceToHave = lazy(() => import("../pages/Prefrences/comapre-nice-to-have"))
const Notifications = lazy(() => import("../pages/Notification/index"))
const support = lazy(() => import("../pages/Prefrences/support"))
const helpfullinks = lazy(() => import("../pages/Prefrences/helpfullinks"))
const helpfuldocument = lazy(() => import("../pages/Prefrences/helpfuldocument"))

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },

  { path: "/appointment", component: clientApp },
  { path: "/documents", component: ClientDocument },
  { path: "/messages", component: ClientMessage },

  // Investor / Pre-Construction — also enabled for Buyer (1) and Seller (2)
  { path: "/project", component: Project, requiredClientTypes: [1, 2, 4] },
  { path: "/project-detail/:id/:projectId", component: ProjectDetail, requiredClientTypes: [1, 2, 4] },
  { path: "/project-compare", component: ProjectComapre, requiredClientTypes: [1, 2, 4] },
  { path: "/my-interests", component: myProject, requiredClientTypes: [1, 2, 4] },
  { path: "/my-transection", component: myTransection, requiredClientTypes: [1, 2, 4] },

  { path: "/my-compare", component: MlsComapre },
  { path: "/deals", component: deals },

  // Seller (clientTypeCode: 2)
  { path: "/seller-showings", component: SellerShowing, requiredClientType: 2 },

  // Buyer (clientTypeCode: 1)
  { path: "/buyer-prefrences", component: preFrence, requiredClientType: 1 },
  { path: "/prefrences/home-prefrences", component: homePref, requiredClientType: 1 },
  { path: "/prefrences/important-destinations", component: impDates, requiredClientType: 1 },

  { path: "/my-listing", component: myListing },
  { path: "/create-listing", component: createListing },
  { path: "/professional-services", component: mySource },
  { path: "/calculator", component: calCulator },
  { path: "/my-lawyers", component: MyLawyer },
  { path: "/profile", component: clientProfile },
  { path: "/client-profile", component: clientProfileNew },
  { path: "/general-setting", component: generalSetting },
  { path: "/membership", component: memberInfo },

  // Buyer (clientTypeCode: 1)
  { path: "/add-listing", component: addListing, requiredClientType: 1 },
  { path: "/sent-add-listing", component: sentAddListing, requiredClientType: 1 },
  { path: "/received-add-listing", component: receivedAddListing, requiredClientType: 1 },
  { path: "/visited-add-listing", component: VisitedAddListing, requiredClientType: 1 },

  // Seller (clientTypeCode: 2)
  { path: "/prefrences/sellers-checklist", component: sellersChecklist, requiredClientType: 2 },
  { path: "/sellers-checklist", component: sellersChecklist, requiredClientType: 2 },

  // Buyer (clientTypeCode: 1)
  { path: "/buyers-checklist", component: buyersChecklist, requiredClientType: 1 },
  { path: "/manage-listing", component: manageListing, requiredClientType: 1 },
  { path: "/compare-not-match", component: comapreNotMatch, requiredClientType: 1 },
  { path: "/compare-match", component: comapreMatch, requiredClientType: 1 },
  { path: "/compare-nice-to-have", component: comapreNiceToHave, requiredClientType: 1 },

  { path: "/notification", component: Notifications },
  { path: "/support", component: support },
  { path: "/helpful-links", component: helpfullinks },
  { path: "/helpful-documents", component: helpfuldocument },

  { path: "/", exact: true, component: RootRedirect },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/resetpassword", component: ResetPassword },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
]

export { authProtectedRoutes, publicRoutes }
